module.exports = __webpack_public_path__ + "static/media/lock1.968ceb6b.jpg";